import { formatFecha, getEdad } from "./funciones";
import * as uiText from "./uiText";
import moment from "moment";
import { REGEX_RFC } from "./constantes";

//Campo requerido
export const REQUERIDO = [{ required: true, message: uiText.REQUERIDO }];

//Valida solo caracteres alfabéticos
export const TXT_LETRAS = [
  {
    message: uiText.CARACTERES_INVALIDOS,
    pattern:
      /^[a-zA-Z-äëïöüÄËÏÖÜáéíóúÁÉÍÓÚÑñ]+[^0-9{}+\\_!"´#$%\][\\&()=?/¡*'¨°|;,<>-]+$/,
  },
  { validateStatus: "error" },
];

//Valida solo caracteres alfabéticos y el campo es requerido
export const TXT_LETRAS_REQ = [
  { required: true, message: uiText.REQUERIDO },
  {
    message: uiText.CARACTERES_INVALIDOS,
    pattern:
      /^[a-zA-Z-äëïöüÄËÏÖÜáéíóúÁÉÍÓÚÑñ]+[^0-9{}+\\_!"´#$%\][\\&()=?/¡*'¨°|;,<>-]+$/,
  },
  { validateStatus: "error" },
];

//Valida solo caracteres ALFANUMERICO y el campo es requerido tamaño 1000 max
export const TXT_ALFANUMERICO = [
  {
    message: uiText.CARACTERES_INVALIDOS,
    pattern:
      /^([a-zA-Z-áéíóúüÁÉÍÓÚÜ0-9]{0,2000})+[^\\_\\!"$%&#/{}+\]|¿@()\\[=?¡^`*¨°|<>]+$/,
  },
];

//Valida solo caracteres ALFANUMERICO y el campo es requerido tamaño 2000 max
export const TXT_ALFANUMERICO_V2 = [
  {
    message: uiText.CARACTERES_INVALIDOS,
    pattern:
      /^([a-zA-Z-áéíóúüÁÉÍÓÚÜ0-9]{0,2000})+[^\\_\\!"$%&#/{}+\]|¿@()\\[=?¡^`*¨°|<>]+$/,
  },
];

//Valida solo caracteres ALFANUMERICO y el campo es requerido tamaño 100
export const TXT_ALFANUMERICO_REQ = [
  { required: true, message: uiText.REQUERIDO },
  {
    message: uiText.CARACTERES_INVALIDOS,
    pattern:
      /^([a-zA-Z-áéíóúüÁÉÍÓÚÜ0-9]{0,100})+[^\\_\\!"$%&#/{}+\]|¿@()\\[=?¡^`*¨°|<>]+$/,
  },
];

//Valida solo caracteres ALFANUMERICO y el campo es requerido tamaño 100 acepta parentesis
export const TXT_ALFANUMERICO_REQ_PAR100 = [
  { required: true, message: uiText.REQUERIDO },
  {
    message: uiText.CARACTERES_INVALIDOS,
    pattern:
      /^([a-zA-Z-áéíóúüÁÉÍÓÚÜ0-9()]{0,100})+[^\\_\\!"$%&#/{}+\]|¿@\\[=?¡^`*¨°|<>]+$/,
  },
];

//Valida solo caracteres ALFANUMERICO y el campo es requerido tamaño 200 acepta parentesis
export const TXT_ALFANUMERICO_REQ_PAR200 = [
  { required: true, message: uiText.REQUERIDO },
  {
    message: uiText.CARACTERES_INVALIDOS,
    pattern:
      /^([a-zA-Z-áéíóúüÁÉÍÓÚÜ0-9()]{0,200})+[^\\_\\!"$%&#/{}+\]|¿@\\[=?¡^`*¨°|<>]+$/,
  },
];

//Valida la estructura del CURP
export const CURP = [
  { required: true, message: uiText.REQUERIDO },
  {
    message: uiText.FORMATO_INVALIDO,
    pattern: /^[A-Z]{4}[0-9]{6}[H|M][A-Z]{5}[A-Z0-9][0-9]$/i,
  },
  { validateStatus: "error" },
];
//Valida la estructura del RFC
export const RFC = [
  { required: true, message: uiText.REQUERIDO },
  {
    message: uiText.FORMATO_INVALIDO,
    pattern: REGEX_RFC,
  },
  { validateStatus: "error" },
];
//Valida la estructura del Clave de Elector
export const CLAVE_ELECTOR_FUAR = [
  { required: true, message: uiText.REQUERIDO },
  {
    message: uiText.FORMATO_INVALIDO,
    pattern: /^([A-Z]{5,6}\d{8}[H|M]\d{3})$|^([0-9]{13})$/i,
  },
  { validateStatus: "error" },
];
//Valida la estructura del Correo
export const CORREO = [
  { required: true, message: uiText.REQUERIDO },
  {
    type: "email",
    message: uiText.FORMATO_INVALIDO,
  },
  { validateStatus: "error" },
];
//Valida la estructura del Correo y que coincida con el primero
export const CORREO_CONFIRMA = [
  { required: true, message: uiText.CORREO_CONFIRMA },
  {
    type: "email",
    message: uiText.FORMATO_INVALIDO,
  },
  //Se valida que los correos coincidan
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue("email") === value) {
        return Promise.resolve("");
      }
      return Promise.reject(new Error(uiText.CORREO_CONFIRMA_ERROR));
    },
  }),
];

export const PASSWORD = [
  { required: true, message: uiText.REQUERIDO },
  {
    message: uiText.FORMATO_PASS,
    pattern:
      /^(?=(?:.*\d))(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%&¿?_+:;=()/¬|{}])\S{8,15}$/,
  },
];

export const PASS_CONFIRMA = [
  { required: true, message: uiText.PASS_CONFIRMA },
  //Se valida que los correos coincidan
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue("password") === value) {
        return Promise.resolve("");
      }
      return Promise.reject(new Error(uiText.PASS_CONFIRMA_ERROR));
    },
  }),
];

export const DIRECCION = [
  {
    message: uiText.CARACTERES_INVALIDOS,
    pattern:
      /^([a-zA-Z-áéíóúüÁÉÍÓÚÜ0-9]{0,100})+[^\\_\\!"$%&#{}+\]|¿@()\\[=?¡^`*¨°|<>]+$/,
  },
];

export const CP = [
  {
    message: uiText.CODIGO_POSTAL,
    pattern: /^[0-9]+$/,
  },
  { required: true, message: uiText.REQUERIDO },
  { min: 5, message: uiText.CODIGO_POSTAL },
  ({ _ }) => ({
    validator(_, value) {
      if (value !== "00000") {
        return Promise.resolve("");
      }
      return Promise.reject(new Error(uiText.CODIGO_POSTAL));
    },
  }),
];

export const TELEFONO = [
  { message: uiText.CARACTERES_INVALIDOS, pattern: /^[0-9]+$/ },
  { min: 10, message: "Teléfono inválido." },
  { validateStatus: "error" },
];
export const NUMEROS = [  
  { message: uiText.CARACTERES_INVALIDOS, pattern: /^[0-9]+$/ },
  { validateStatus: "error" },
];

export const FECHA_NACIMIENTO = [
  { required: true, message: uiText.REQUERIDO },
  ({ _ }) => ({
    validator(_, value) {
      const fechaNacimiento = formatFecha(value, "YYYY/MM/DD");
      if (getEdad(fechaNacimiento) < 18 && value !== "") {
        return Promise.reject(new Error(uiText.EDAD_NACIMIENTO));
      }
      return Promise.resolve("");
    },
  }),
];

export const FECHAS = [
   ({ _ }) => ({
    validator(_, value) {
      if (value > moment().endOf("day") && value !== "") {
        return Promise.reject(new Error(uiText.REQ_FECHA));
      }
      return Promise.resolve("");
    },
  }),
];

export const FECHAS_REQ = [
  { required: true, message: uiText.REQUERIDO },
  ({ _ }) => ({
   validator(_, value) {
     if (value > moment().endOf("day") && value !== "") {
       return Promise.reject(new Error(uiText.REQ_FECHA));
     }
     return Promise.resolve("");
   },
 }),
];
